/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import React from 'react'
import {assets, routes} from '../../utils/config'
import {Helmet, Toaster} from '../app'

// noinspection HtmlRequiredTitleElement
const AuthLayout = ({children}) => (
  <>
    <Helmet title={routes.login.name} />
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            // backgroundImage: 'linear-gradient(#eed88c, #faab38)',
            backgroundImage: 'linear-gradient(#10b4b0, #662d91)',
            display: 'flex',
            position: 'relative',
            width: 100 + '%',
            height: 100 + '%',
            ':before': {
              content: '""',
              display: 'block',
              width: 100 + '%',
              height: 100 + '%',
              backgroundImage: `url("${assets.auth.clouds}") repeat-x 50% 100%`,
              backgroundSize: 1600 + 'px',
              backgroundRepeat: 'no-repeat',
              backgroundPositionX: 'center',
              backgroundPositionY: 'top',
              position: 'absolute',
              top: 0,
              left: 0,
            },
            ':after': {
              content: '""',
              display: 'block',
              width: 100 + '%',
              height: 100 + '%',
              backgroundImage: `url("${assets.auth.varvistaDark}")`,
              backgroundSize: 1920 + 'px',
              backgroundRepeat: 'repeat-x',
              backgroundPositionX: 'center',
              backgroundPositionY: 'bottom',
              position: 'absolute',
              top: 0,
              left: 0,
              [$theme.media.medium]: {
                backgroundSize: 1920 + 'px',
              },
            },
          }),
        },
      }}
    >
      <Block
        $as="main"
        overrides={{
          Block: {
            style: ({$theme}) => ({
              marginTop: $theme.sizing.scale800,
              marginLeft: 'auto',
              marginRight: 'auto',
              paddingLeft: $theme.sizing.scale800,
              paddingRight: $theme.sizing.scale800,
              width: 100 + '%',
              maxWidth: 30 + 'rem',
              position: 'relative',
              overflow: 'hidden',
              zIndex: 1,
              [$theme.media.medium]: {
                marginTop: $theme.sizing.scale2400,
                overflow: 'hidden',
              },
            }),
          },
        }}
      >
        {children}
      </Block>
    </Block>
    <Toaster />
  </>
)

export default AuthLayout
